import React from 'react';

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Typography from '@ts-core/components/Typography';

import ExerciseText from '../ExerciseText';
import ExerciseMedia from '../ExerciseMedia';
import ExerciseExplanation from '../ExerciseExplanation';

import { CoreExercise } from '../../types';

interface ExercisePreviewContainerProps {
  children: React.ReactNode;
  exercise?: CoreExercise;
  loading?: boolean;
  layout?: 'column' | 'row';
}

const ExercisePreviewContainer = (props: ExercisePreviewContainerProps) => {
  const { children, exercise, loading = false, layout = 'row' } = props;
  const textOrMedia = exercise?.text || (exercise?.media && exercise.media.length) || loading;

  return (
    <Paper sx={{ mb: 1, p: 2 }}>
      <Typography variant="h6" fontWeight={500} py={2} loading={loading} skeletonProps={{ width: 160 }}>
        {exercise?.code}
      </Typography>
      <Stack direction={{ xs: 'column', lg: layout }} spacing={1}>
        {textOrMedia && (
          <Box width={{ xs: '100%', lg: layout === 'row' ? '70%' : '100%' }}>
            <ExerciseText text={exercise?.text} loading={loading} />
            {!loading && <ExerciseMedia media={exercise?.media} />}
          </Box>
        )}
        <Box
          width={{ xs: '100%', lg: textOrMedia && layout === 'row' ? '25%' : '100%' }}
          pl={{ xs: 0, lg: textOrMedia && layout === 'row' ? 1 : 0 }}
          borderLeft={{ xs: 0, lg: textOrMedia && layout === 'row' ? 1 : 0 }}
        >
          {children}
        </Box>
      </Stack>
      {exercise && <ExerciseExplanation exercise={exercise} />}
    </Paper>
  );
};

export default ExercisePreviewContainer;
